export default __webpack_public_path__ + "static/media/to-do-list-tablet.c9576e7c.png";